const panEntryOptions = [
  {
    "key": "UNSPECIFIED",
    "text": "Unspecified"
  },
  {
    "key": "MANUAL",
    "text": "Manual"
  },
  {
    "key": "MAGNETIC_STRIPE",
    "text": "Magnetic stripe"
  },
  {
    "key": "QR_OR_BARCODE",
    "text": "Qr or barcode"
  },
  {
    "key": "OCR",
    "text": "Ocr"
  },
  {
    "key": "INTEGRATED_CIRCUIT_CARD",
    "text": "Integrated circuit card"
  },
  {
    "key": "KEY_ENTERED",
    "text": "Key entered"
  },
  {
    "key": "CONTACTLESS",
    "text": "Contactless"
  },
  {
    "key": "ELECTRONIC",
    "text": "Electronic"
  },
  {
    "key": "CHIP_FAILURE_USED_MANUAL",
    "text": "Chip failure used manual"
  },
  {
    "key": "CHIP_FAILURE_USED_TRACK",
    "text": "Chip failure used track"
  },
  {
    "key": "FROM_FILE",
    "text": "From file"
  },
  {
    "key": "FROM_SERVER",
    "text": "From server"
  },
  {
    "key": "FROM_OTHER_CARDLESS_ENTRY",
    "text": "From other cardless entry"
  },
  {
    "key": "MAGNETIC_STRIPE_FULL",
    "text": "Magnetic stripe full"
  },
  {
    "key": "MAGNETIC_STRIPE_CONTACTLESS",
    "text": "Magnetic stripe contactless"
  },
  {
    "key": "INTEGRATED_CIRCUIT_CARD_UNRELIABLE_CVV",
    "text": "Integrated circuit card unreliable CVV"
  },
];

export default panEntryOptions;